module.exports = __webpack_public_path__ + "img/faq-cat_71265f3.webp";